<template>
  <div class="to-compare col-flex pa-2">
    <v-btn class="mx-2 remove-btn mb-8 ml-auto" fab dark color="#F5542D" x-small @click="$emit('closeForm')">
      <v-icon color="white" dark>mdi-close</v-icon>
    </v-btn>
    <div class="text color-primary size-24 font-weight-bold mx-auto mb-5">
      Wähle 2 Autos zum Vergleichen aus!
    </div>
    <v-text-field
      v-model="search"
      class="input mx-auto mb-5"
      append-icon="mdi-magnify"
      outlined
      rounded
    />
    <div class="vehicle-list px-2 my-5">
      <template v-if="filteredVehicles.length > 0">
        <div
          class="pointer"
          v-for="vehicle in filteredVehicles"
          :key="vehicle.id"
          @click="addToCompare(vehicle.id)"
        >
          <v-layout class="py-3" justify-space-between>
            <v-layout class="size-18 color-primary" column>
              <span class="font-weight-bold">{{vehicle.name}}</span>
              <span>{{vehicle.model}}</span>
            </v-layout>
            <img class="vehicle-img" :src="require(`@/assets/img/vehicles/${vehicle.image}`)" />
          </v-layout>
        </div>
      </template>
      <div class="py-3 color-primary weight5 text-center" v-else>
        Keine Autos gefunden
      </div>
    </div>
  </div>
</template>

<script>
import vehicles from '@/api/vehicles.json'

export default {
  name: 'to-compare',
  data: () => ({
    vehicles,
    search: ''
  }),
  computed: {
    toCompare: function() {
      return this.$store.state.toCompare;
    },
    filteredVehicles: function() {
      return vehicles.filter(vehicle => {
        if(this.toCompare.indexOf(vehicle.id) !== -1)
          return false;
        if(this.search) {
          let search = this.search.toLowerCase();
          let {name, model} = vehicle;
          if(name.toLowerCase().indexOf(search) !== -1 || model.toLowerCase().indexOf(search) !== -1)
            return true;
          else
            return false;
        }
        return true;
      })
    }
  },
  methods: {
    addToCompare(id) {
      this.$store.commit("ADD_TO_COMPARISON", {id, toast: this.$toasted});
      if(this.toCompare.length == 2)
        this.$emit('closeForm');
    }
  }
}
</script>

<style lang="scss">
.to-compare {
  .text {
    width: 314px;
    text-align: center;
  }
  .input {
    height: 50px;
    width: 316px;
  }
  .vehicle-list {
    > div {
      border-bottom: 1px solid #9FAEB8;
      transition: all 0.25s;
    }
    > div:first-child {
      border-top: 1px solid #9FAEB8;
    }
  }
  .vehicle-img {
    height: 68px;
    width: 68px;
    object-fit: cover;
    object-position: center center;
    max-width: 68px;
    border-radius: 14px;
  }
}
</style>